module.exports = __webpack_public_path__ + "img/help.d0980077.png";